import React from 'react'
import { RestoreQuestionFlowProvider } from './context/RestoreQuestionFlowProvider'
import { RestoreQuestionFlowMain } from './components/RestoreQuestionFlowMain'

export const RestoreQuestionFlow = () => {
  return (
    <RestoreQuestionFlowProvider>
      <RestoreQuestionFlowMain />
    </RestoreQuestionFlowProvider>
  )
}
